<template>
  <div class="home">
    <h2>Users Logs</h2>

    <b-container fluid>
      <b-row>
        <b-col md="12" class="my-1">
          <b-form-group label-cols-sm="1" label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter.userId"
                placeholder="by User ID"
                @keypress.enter="forceFilter"
              />
              <b-form-input
                v-model="filter.baseUrl"
                placeholder="by Path to Controller"
                @keypress.enter="forceFilter"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter.userId && !filter.baseUrl"
                  @click="
                    filter = {};
                    forceFilter();
                  "
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="usersLogsTable"
        class="usersLogsTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
          >
            …
          </b-button>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: {
        userId: '',
        baseUrl: ''
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'userId',
          label: 'User Id',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'user.role',
          label: 'Role',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'user.email',
          label: 'User email',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'baseUrl',
          label: 'Path to controller',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'routePath',
          label: 'Controller method name',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.usersLogs.count;
    }
  },
  methods: {
    forceFilter() {
      this.onFiltered();
      this.$refs.usersLogsTable.refresh();
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const currentFilter = Object.keys(this.filter).reduce(
        (acc, curr) =>
          this.filter[curr] ? { ...acc, [curr]: this.filter[curr] } : acc,
        {}
      );
      const promise = this.$store.dispatch('getUsersLogs', {
        ctx,
        filter: currentFilter
      });

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        return this.$store.state.usersLogs.rows || [];
      });
    }
  }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.usersLogsTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
